import {Fragment} from 'react';
import {UserAvatar} from '@/components/app/feedback';
import {AvatarStack} from '@/components/app/feedback';
import {ContentHints} from '@/components/app/hint';
import {cn} from '@/lib/utils';
import {useBiotwinHubUsers} from '../hooks/useBiotwinHubUsers';
const colors = ['bg-blue-500', 'bg-green-500', 'bg-orange-500', 'bg-purple-500'];
const threshold = 3;
export interface BiotwinViewersProps {
  biotwinUserId: number;
  className?: string;
}
export const BiotwinHubUsers = ({biotwinUserId, className}: BiotwinViewersProps) => {
  const biotwinHubUsers = useBiotwinHubUsers(biotwinUserId);
  const uniqueBiotwinHubUsers = biotwinHubUsers.filter(
    (user, i, a) => a.findIndex((u) => u.userId === user.userId) === i,
  );
  if (uniqueBiotwinHubUsers.length === 0) {
    return null;
  }
  return (
    <div className={cn('flex items-center w-full', className)}>
      <span className={'ml-4'}>Others</span>
      <AvatarStack className={'ml-auto'}>
        {uniqueBiotwinHubUsers.slice(0, threshold).map((user, index) => (
          <Fragment key={index}>
            <UserAvatar
              className={cn(colors[index % colors.length], 'text-white')}
              id={`biotwin-hub-user-${user.userId}`}
              key={user.userId}
              label={user.name
                .split(' ')
                .map((p) => p[0])
                .join('')}
              shape="circle"
            />
            <ContentHints content={user.name} side={'left'} target={`#biotwin-hub-user-${user.userId}`} />
          </Fragment>
        ))}
        {uniqueBiotwinHubUsers.length > threshold && (
          <>
            <UserAvatar
              className={'bg-gray-800 text-white'}
              id={'biotwin-hub-user-more'}
              label={`+${uniqueBiotwinHubUsers.length - threshold}`}
              shape="circle"
            />
            <ContentHints
              content={uniqueBiotwinHubUsers
                .slice(threshold)
                .map((user) => user.name)
                .join(', ')}
              target={`#biotwin-hub-user-more`}
            />
          </>
        )}
      </AvatarStack>
    </div>
  );
};
